export type ProgressTone = "info" | "warning" | "success" | "danger"

export function progressTone(percent: number): ProgressTone {
  if (percent >= 100) return "success"
  if (percent >= 50) return "info"
  return "warning"
}
